import { useEffect } from "react";
import { useLocationConfigContext } from "./context/LocationConfigContext";
import { LocationConfigProvider } from "./context/LocationConfigContext";
import MainLayoutConfigView from "./MainLayoutConfigView";

function clearLocationFilterState() {
    const prefixesToClear = ["locationBedsTable", "mobileFilter_locationBedsTable"];

    const clearStorage = (storageTarget: Storage) => {
        Object.keys(storageTarget).forEach((key) => {
            if (prefixesToClear.some((prefix) => key.startsWith(prefix))) {
                storageTarget.removeItem(key);
            }
        });
    };

    clearStorage(sessionStorage);
    clearStorage(localStorage);
}

function LocationConfigContent() {
    const { setActiveTab } = useLocationConfigContext();

    useEffect(() => {
        clearLocationFilterState();
        setActiveTab(0);
        return () => clearLocationFilterState();
    }, [setActiveTab]);

    return <MainLayoutConfigView />;
}

export default function LocationConfigView() {
    return (
        <LocationConfigProvider>
            <LocationConfigContent />
        </LocationConfigProvider>
    );
}
